module.exports = __webpack_public_path__ + "static/img/vite-logo.ec30cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vite-logo.jpg
// module id = owz2
// module chunks = 15